import Vue from 'vue'
import vueDebounce from 'vue-debounce'

Vue.use(vueDebounce, {
  lock: false,
  // Listening to multiple events
  listenTo: ['input', 'keyup'],
  defaultTime: '2s',
  fireOnEmpty: false
})
